export const TYPE_LIVE_READ = { id: 1, name:'Live Reads' };
export const TYPE_PRE_RECORDED = { id: 2, name:'Pre-recorded Spots' };
export const TYPE_WATCHLIST = { id: 3, name:'Watchlists (Mentions)' };
export const CREATIVE_CHART_ID = 9;
export const CREATIVE_CHART_FILE_NAME = 'creative_analytics_chart';

export const typeOptions = {
  visitOfads: {
    value: 'visitOfads',
    label: 'Ad Visits/Ads'
  },
  avgAdCost: {
    value: 'avgAdCost',
    label: 'Avg. Ad Cost'
  },
  visits: {
    value: 'visits',
    label: 'Ad Visits'
  },
  adUser: {
    value: 'adUser',
    label: 'Ad Users'
  },
  creative_name: {
    value: 'creative_name',
    label: 'By Creative',
  },
  creative_duration: {
    value: 'creative_duration',
    label: 'By Duration',
  }
}
